import type { NonAgentJsonType } from '@bb/domain/dist/types/NonAgent';
import axios, { type AxiosRequestConfig } from 'axios';

const update = async (
  nonAgent: Omit<
    NonAgentJsonType,
    | '_id'
    | 'id'
    | 'createdBy'
    | 'createdAt'
    | 'org'
    | 'isDeleted'
    | 'onboardingPortalId'
    | 'preApproved'
    | 'uid'
    | 'updatedAt'
    | 'updatedBy'
  >,
  nonAgentId: string,
) => {
  const config: AxiosRequestConfig = {
    url: `/nonagent/${nonAgentId}`,
    method: 'post',
    data: nonAgent,
  };

  const { data } = await axios.request<NonAgentJsonType>(config);
  return data;
};
export default update;
